/**
 * Prüfungen für Zahlen- und Größenfelder der Editor-Dialoge.
 *
 * Ungültige Eingaben liefern null, damit der Dialog eine Meldung zeigen kann,
 * statt stillschweigend einen anderen Wert zu übernehmen (z. B. "test" als
 * Breite, die dann als ungültiges CSS verschwindet).
 */

/** Ganzzahl im erlaubten Bereich, sonst null. */
export function parseIntegerInput(raw: string, min: number, max: number): number | null {
  const value = raw.trim();
  if (!/^\d+$/.test(value)) return null;
  const amount = parseInt(value, 10);
  return amount >= min && amount <= max ? amount : null;
}

export interface SizeInputLimits {
  /** Obergrenze für Pixelwerte. */
  maxPx?: number;
  /** Prozentangaben zulassen (Standard: ja). */
  allowPercent?: boolean;
}

/**
 * Normalisiert eine Größenangabe: "40" und "40px" ergeben "40px", "50%" bleibt.
 * Leere Eingabe ergibt "" (= automatisch), ungültige Eingabe null.
 */
export function normalizeSizeInput(raw: string, limits: SizeInputLimits = {}): string | null {
  const value = raw.trim().toLowerCase();
  if (!value) return "";
  const match = /^(\d+)\s*(px|%)?$/.exec(value);
  if (!match) return null;
  const amount = parseInt(match[1], 10);
  if (match[2] === "%") {
    if (limits.allowPercent === false) return null;
    return amount >= 1 && amount <= 100 ? `${amount}%` : null;
  }
  return amount >= 1 && amount <= (limits.maxPx ?? 2000) ? `${amount}px` : null;
}
